import { Tip } from '@vzmi/shp_shared_compo'

export default Tip
